import {Client} from '../../../graphql/types'

const AFFILIATE_ID = 36389

export const overrideFor36389 = (accounts: any[], client: Client) => {
  if (client.affiliateId !== AFFILIATE_ID) return accounts

  return accounts.filter(account => !['basic', 'black', 'mt5Std', 'mt5Vip'].includes(account.accountSubtype))
}
